<template>
	<v-form ref="form" v-model="valid" v-if="!!subEvents.length">
		<v-row v-for="(item, i) in subEvents" :key="i">
			<v-col>
				<v-text-field outlined dense
					hide-details="auto"
					:label="`${item.text} - ${$t('text.bestResult')}`"
					min="0"
					:rules="[rules.notEmpty]"
					v-model="values[i].result"
					@keyup="formatbestResult(i)">
				</v-text-field>
			</v-col>
			<v-col>
				<v-text-field outlined dense
					hide-details="auto"
					:label="$t('text.points')"
					min="0"
					:rules="[rules.notEmpty, rules.isNumber]"
					v-model.number="values[i].points">
				</v-text-field>
			</v-col>
			<v-col>
				<v-text-field outlined dense
					v-if="item.ec.wind && environment && eventClass.wind"
					hide-details="auto"
					:label="$t('text.windResult')"
					:rules="[rules.notEmpty]"
					v-model="values[i].windResult"
					@keyup="formatWind(i)">
				</v-text-field>
				<v-text-field outlined dense
					v-if="item.ec.wind && environment && !eventClass.wind"
					hide-details="auto"
					:label="$t('text.windResult')"
					v-model="values[i].windResult"
					@keyup="formatWind(i)">
				</v-text-field>
			</v-col>
		</v-row>
	</v-form>
</template>

<script>

import modelState from '../mixins/modelState';
import formater from '../mixins/formater';
import GUID from '../mixins/GUIDMixin';

class Event {
	constructor(id, event, result, points, heightWeight, wind) {
		this.id = id || this.EmptyGUID;
		this.eventId = event;
		this.result = result || null;
		this.points = points || null;
		this.heightWeight = heightWeight || null;
		this.windResult = wind || null;
	}
}

export default {
	name: 'MultiEventEditor',
	mixins: [modelState, formater, GUID],
	data() {
		return {
			values: this.value || [],
			valid: false,
			rules: {
				notEmpty: v => (v !== null && String(v).trim() !== '') || this.$i18n.t('text.errorEmpty'),
				isNumber: v => Number.isInteger(v) || this.$i18n.t('text.errorShouldBeNumber'),
			},
		};
	},
	props: {
		loading: {
			type: Boolean,
			require: true,
			default: true,
		},
		subEvents: {
			default: () => [],
			require: true,
		},
		environment: {
			type: Number,
			require: true,
			default: 1,
		},
		value: {
			type: Array,
			required: false,
		},
		eventClass: {
			required: false,
		},
	},
	computed: {
		isValid() {
			return this.valid;
		},
	},
	methods: {
		formatWind(i) {
			this.values[i].windResult = this.gFormatWind(this.values[i].windResult);
		},
		formatbestResult(z) {
			this.values[z].result = this.gFormatbestResult(this.values[z].result, this.subEvents[z].measurement);
		},
		initValues() {
			this.values = [];
			this.subEvents.forEach(x => this.values.push(new Event(null, x.value, null, null, x.ec.heightWeight)));
		},
	},
	watch: {
		subEvents() {
			if (this.value?.length !== this.subEvents.length) {
				this.initValues();
			}
		},
		isValid() {
			this.$emit('validate', this.isValid);
			this.$emit('input', this.values);
		},
		values: {
			deep: true,
			handler() {
				this.$emit('input', this.values);
			},
		},
		value() {
			if (this.value?.length == 0 && this.$refs?.length != 0) {
				// eslint-disable-next-line no-unused-expressions
				this.$refs.form?.reset();
				this.initValues();
			} else {
				this.values = this.value;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
</style>
